import React from "react";

export const DetailsContainer = ({ children, isDetailsActive }) => {
  if (!isDetailsActive) return null;

  return <div className="detailsContainer">{children}</div>;
};
